var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-item",attrs:{"href":_vm.url}},[_c('div',{staticClass:"nav-item__icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"nav-item__title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }